import React, {useEffect} from 'react'
import {Redirect, useHistory} from 'react-router-dom'
import {useAuthenticationState, useRegistrationState} from 'users/hooks'
import {
  Layout,
  Body,
  Info,
  Main,
  FeatureList
} from 'ui/components/DividedLayout'
import Signup from './Signup'
import SetPassword from './SetPassword'
import SwitchToLogin from './SwitchToLogin'

const Registration = props => {
  const {isAuthenticated} = useAuthenticationState()
  const {status} = useRegistrationState()
  const history = useHistory()

  // Redirect to catalog when user is authenticated (after successful registration)
  useEffect(() => {
    if (isAuthenticated) {
      history.push('/catalog')
    }
  }, [isAuthenticated, history])

  if (isAuthenticated) return <Redirect to='/catalog' />

  let component = <Signup {...props} />
  if (status === 'succeeded') component = <SetPassword {...props}/>

  return (
    <Layout>
      <Body>
        <Info>
          <FeatureList />
          <SwitchToLogin />
        </Info>
        <Main>{component}</Main>
      </Body>
    </Layout>
  )
}

export default Registration
